import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { toggleDarkMode } from "../../redux/theme/themeSlice";
import { MdOutlineDarkMode, MdOutlineLightMode } from "react-icons/md";

const ThemeToggle = ({ className }) => {
  const { t } = useTranslation();
  const { darkMode } = useSelector((state) => state.theme);
  const dispatch = useDispatch();

  return (
    <div className="mr-2 flex items-center">
      <button
        type="button"
        onClick={() => dispatch(toggleDarkMode())}
        aria-label={t("common.theme")}
        aria-pressed={darkMode}
        title={t("common.theme")}
        className={`cursor-pointer text-3xl text-[--tx-1] bg-transparent flex items-center rounded-full ${className}`}
      >
        {darkMode ? (
          <MdOutlineDarkMode className="rotate-45" aria-hidden="true" />
        ) : (
          <MdOutlineLightMode aria-hidden="true" />
        )}
      </button>
    </div>
  );
};

export default ThemeToggle;
